import { render, staticRenderFns } from "./PrveDomy.vue?vue&type=template&id=6515cbb3&scoped=true"
import script from "./PrveDomy.vue?vue&type=script&lang=js"
export * from "./PrveDomy.vue?vue&type=script&lang=js"
import style0 from "./PrveDomy.vue?vue&type=style&index=0&id=6515cbb3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515cbb3",
  null
  
)

export default component.exports